import React, { ReactNode } from 'react';
import { Grid, Typography, CircularProgress, Button, Paper, IconButton, Container, Zoom, ZoomProps, styled, Box, Fab, useMediaQuery } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import appTema from '../../servicos/mui/Theme';
import { useAppContextoReact } from '../../servicos/app/AppContextoReact';
import ChecklistIcon from '@mui/icons-material/Checklist';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import { DataType } from '../../servicos/IFormularios';

interface AddEditComponentProps {
	ehDialog: boolean,
	bgColor?: string
	tituloCaller: string;
	onSubmitingCaller: boolean;
	listViews?: boolean;
	dataType?: DataType;
	handleSubmitCaller: () => void;
	openCaller?: boolean;
	onCloseCaller?: () => void;
	children: ReactNode;
}

const Transition = React.forwardRef<HTMLDivElement, ZoomProps>((props, ref) => (
	<Zoom ref={ref} {...props} />
));

const AddEditComponent: React.FC<AddEditComponentProps> = ({ ehDialog: ehDialog, bgColor, listViews, dataType, tituloCaller, onSubmitingCaller, handleSubmitCaller, openCaller, onCloseCaller, children }) => {

	const appContext = useAppContextoReact();

	const [userRoleAdmin, setUserRolerAdmin] = React.useState<boolean|null|undefined>(null);

	const viewList = listViews ? listViews : false

	React.useEffect(() =>
	{
		setUserRolerAdmin(appContext.permissao.administrador)
	},[appContext])

	let Content = (
		<>
			<Grid container spacing={2} component={'form'} id="formulario" className={viewList ? 'viewList' : ''} onSubmit={handleSubmitCaller} sx={{ overflow:!ehDialog ? 'hidden' : 'none' }}>
				<Grid item xs={12}>
					{ ehDialog ?
						<Grid container spacing={2} component={'fieldset'}>
							{/* Aqui é onde os elementos adicionais serão renderizados */}
							{children}
						</Grid>
					:
						<Paper variant='outlined' sx={{ p:2, display:'flex', flexDirection:'column', backgroundColor:bgColor ? bgColor : '#fff' }}>
							<Grid container spacing={2} component={'fieldset'}>
								{/* Aqui é onde os elementos adicionais serão renderizados */}
								{children}
							</Grid>
						</Paper>
					}
				</Grid>
			</Grid>
		</>
	);
	let Buttons = (
		<>
			<Grid container alignItems={'center'} justifyContent={'space-between'} flexWrap={'nowrap'} columnGap={2}>
				<Grid item xs>
					{onSubmitingCaller && dataType && dataType !== DataType.PROGRAMA && dataType !== DataType.SERIE && (
						<Typography variant="caption" color="textSecondary">
							O upload está em andamento e pode levar alguns segundos. Por favor, aguarde.
						</Typography>
					)}
				</Grid>
				<Grid item container xs={6} justifyContent="flex-end" alignItems={'center'} flexWrap={'nowrap'} columnGap={2}>
					{ onSubmitingCaller ?
						<CircularProgress color="warning"/>
					:
						<>
						{
							userRoleAdmin && !viewList ?
								<>
									{
										!dataType ?
											<Button type="submit" form="formulario" color="primary" size="large" variant="contained" startIcon={<SaveOutlinedIcon/>}>Salvar</Button>
										:
											<>
												{
													dataType == DataType.PROGRAMA ?
														<Button type="submit" form="formulario" color="primary" size="large" variant="contained" startIcon={<SaveOutlinedIcon/>} endIcon={<ChecklistIcon />}>
															Salvar Programa
														</Button>
													: 
													dataType == DataType.SERIE ?
														<Button type="submit" form="formulario" color="primary" size="large" variant="contained" startIcon={<SaveOutlinedIcon/>} endIcon={<ChecklistIcon />}>
															Salvar Série
														</Button>
													:
														<Button type="submit" form="formulario" color="success" size="large" variant="contained" startIcon={<SaveOutlinedIcon/>} endIcon={<AttachFileIcon />}>
															Salvar Anexos
														</Button>
												}

											</>
									}
								</>
							: ''
						}
						{ 
						ehDialog &&
							<Button onClick={() => handleClose('close')} color="primary" size="large" variant="outlined" startIcon={<CancelOutlinedIcon/>}>{userRoleAdmin && !viewList ? 'Cancelar' : 'Fechar'}</Button>
						}
						</>
					}
				</Grid>
			</Grid>
		</>
	);

	const handleClose = (reason) => {
		if (reason === 'close') {
			onCloseCaller();
		} else {
			// Lidar com o clique no fundo aqui, se necessário.
			// Você pode optar por não fechar o diálogo neste caso.
		}
	};

	const isSmallScreen = useMediaQuery(appTema.breakpoints.down('md'));
	const fabSize = isSmallScreen ? 'small' : 'medium';
	return ehDialog ? (
		<>
		<BootstrapDialog
			open={openCaller}
			onClose={(event, reason) => handleClose(reason)}
			TransitionComponent={Transition}
			transitionDuration={500}
			aria-labelledby={tituloCaller}
			aria-describedby={tituloCaller}
			scroll="paper"
			fullScreen={false}
			maxWidth={'lg'}
			disableEscapeKeyDown={true}
		>
			<DialogTitle sx={{px:2, bgcolor:appTema.palette.secondary.main, color:appTema.palette.secondary.contrastText}}>{tituloCaller}</DialogTitle>
			<IconButton onClick={() => handleClose('close')} sx={{ position:'absolute', right:16, top:12, color:appTema.palette.primary.contrastText }} aria-label="Fechar"><CloseIcon/></IconButton>
			<DialogContent sx={{px:2}} dividers>
				{Content}
			</DialogContent>
			{
				
				<DialogActions>
					{Buttons}
				</DialogActions>
			}
		</BootstrapDialog>
		</>
	) : (
		<Container>
			<Grid item xs={12} sx={{ position:"fixed", zIndex:10 }}>
				<Paper variant='elevation' sx={{ p:1, position:"absolute", top:"2rem", left:"3.5rem", display:'flex', flexDirection:'row' }}>
					<Fab
						title="Salvar"
						aria-label="Salvar"
						form="formulario"
						type="submit"
						color="primary"
						size={fabSize}
						variant="circular"
						// sx={{ position:"absolute", left:"3.5rem", top:"2.5rem" }}
					>
						<SaveOutlinedIcon/>
					</Fab>
				</Paper>
			</Grid>
			<Grid container item justifyContent="space-between" alignItems="center" sx={{ marginBottom:"1rem" }}>
				<Typography component={'span'} variant={'h2'}>{tituloCaller}</Typography>
			</Grid>
			{Content}
			<Box py={2}>
				{Buttons}
			</Box>
		</Container>
	);
}
export default AddEditComponent;

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
	'& .MuiDialogActions-spacing': {
		padding: theme.spacing(2),
	 },
 }));

const BootstrapDialogActions = styled(DialogActions)(({ theme }) => ({
}));
